import { useEffect, useRef, useState } from 'react';
import { FaBars, FaChevronDown, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setServicesOpen(false);
  };
  const toggleServices = () => setServicesOpen(!servicesOpen);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            {/* Use the new logo.jpg with clear white background */}
            <img
              src={`${process.env.PUBLIC_URL}/logo.jpg`}
              alt="KSA Holidays logo"
              className="brand-mark"
            />

            {/* Render wordmark in DOM using Times New Roman so it looks native */}
            <div className="brand-wordmark">
              <div className="brand-title">
                <span className="ksa">KSA</span>
                <span className="holidays">Holidays</span>
              </div>
              <div className="brand-tagline">Your Journey, Our Passion</div>
            </div>
          </Link>

          <div className="menu-icon" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>

          <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeMenu}>
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={closeMenu}>
                About Us
              </Link>
            </li>

            {/* Services Dropdown */}
            <li className="nav-item dropdown" ref={dropdownRef}>
              <button
                className="nav-link dropdown-toggle"
                onClick={toggleServices}
              >
                Services <FaChevronDown className="dropdown-icon" />
              </button>
              <ul className={servicesOpen ? 'dropdown-menu active' : 'dropdown-menu'}>
                <li>
                  <Link to="/services/international-flights" className="dropdown-item" onClick={closeMenu}>
                    International Flights
                  </Link>
                </li>
                <li>
                  <Link to="/services/domestic-flights" className="dropdown-item" onClick={closeMenu}>
                    Domestic Flights
                  </Link>
                </li>
                <li>
                  <Link to="/services/accommodation" className="dropdown-item" onClick={closeMenu}>
                    Accommodation
                  </Link>
                </li>
                <li>
                  <Link to="/services/travel-insurance" className="dropdown-item" onClick={closeMenu}>
                    Travel Insurance
                  </Link>
                </li>
                <li>
                  <Link to="/services/mice" className="dropdown-item" onClick={closeMenu}>
                    MICE
                  </Link>
                </li>
                <li>
                  <Link to="/tours" className="dropdown-item" onClick={closeMenu}>
                    Tour Packages
                  </Link>
                </li>
                <li>
                  <Link to="/services/visa-passport" className="dropdown-item" onClick={closeMenu}>
                    VISA & Passport Assistance
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link to="/why-choose-us" className="nav-link" onClick={closeMenu}>
                Why Choose Us
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={closeMenu}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
